import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { IPagination } from '../models';
import { ISorting } from '../models/sorting';

export class QueryStringBuilder {

    private queries: string[] = new Array<string>();

    public withPaginationIfNotEmpty(pagination?: IPagination): QueryStringBuilder {

        if (!pagination) {

            return this;
        }

        if (pagination.page) {

            this.withQueryIfNotEmpty('page', pagination.page);
        }

        if (pagination.pageSize) {

            this.withQueryIfNotEmpty('pageSize', pagination.pageSize);
        }

        return this;
    }

    public withSorting<T>(sorting?: ISorting<T>): QueryStringBuilder {

        if (!sorting) {
            return this;
        }

        this.withQueryIfNotEmpty('sortField', sorting.field);
        this.withQueryIfNotEmpty('sortDirection', sorting.direction);

        return this;
    }

    public withCultureAliasIfNotEmpty(cultureAlias?: string): QueryStringBuilder {

        this.withQueryIfNotEmpty(`cultureAlias`, cultureAlias);

        return this;
    }

    public withQueryArrayIfNotEmpty<T>(key: string, values: T[]) {

        ArgumentValidator.notNullOrEmpty(key, 'key');

        if (!values || (values && values.length <= 0)) {

            return this;
        }

        values.forEach(value => {

            this.withQueryIfNotEmpty(key, value);
        });

        return this;
    }

    public withBooleanQuery(key: string, value: boolean): QueryStringBuilder {

        ArgumentValidator.notNullOrEmpty(key, 'key');

        this.queries.push(`${key}=${value}`);

        return this;
    }

    public withQueryIfNotEmpty(key: string, value: any): QueryStringBuilder {

        ArgumentValidator.notNullOrEmpty(key, 'key');

        if (!value) {

            return this;
        }

        this.queries.push(`${key}=${value as string}`);

        return this;
    }

    public build(baseUri: string): string {

        ArgumentValidator.notNullOrEmpty(baseUri, 'baseUri');

        let index = 0;

        let queryString = '';

        this.queries.forEach(query => {

            const separator = index === 0 ? '?' : '&';

            queryString += `${separator}${query}`;

            index++;
        });

        return `${baseUri}${queryString}`;
    }
}
